// PHASE 4: What frustrated you most about learning?
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '😴',
    title: 'pages.onboarding.biggestFrustration.answer1',
    subtitle: 'pages.onboarding.biggestFrustration.answer1Subtitle',
  },
  {
    emoji: '🤐',
    title: 'pages.onboarding.biggestFrustration.answer2',
    subtitle: 'pages.onboarding.biggestFrustration.answer2Subtitle',
  },
  {
    emoji: '⏰',
    title: 'pages.onboarding.biggestFrustration.answer3',
    subtitle: 'pages.onboarding.biggestFrustration.answer3Subtitle',
  },
  {
    emoji: '📉',
    title: 'pages.onboarding.biggestFrustration.answer4',
    subtitle: 'pages.onboarding.biggestFrustration.answer4Subtitle',
  },
  {
    emoji: '😤',
    title: 'pages.onboarding.biggestFrustration.answer5',
    subtitle: 'pages.onboarding.biggestFrustration.answer5Subtitle',
  },
  {
    emoji: '🌟',
    title: 'pages.onboarding.biggestFrustration.answer6',
    subtitle: 'pages.onboarding.biggestFrustration.answer6Subtitle',
  },
]

export default function BiggestFrustrationPage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.biggestFrustration.title"
      subtitle="pages.onboarding.biggestFrustration.subtitle"
    />
  )
}
